import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

const BodyLock = ({
  active
}) => {
  const lockRef = useRef(null);
  useEffect(() => {
    active ? disableBodyScroll(lockRef.current) : enableBodyScroll(lockRef.current);
    return () => clearAllBodyScrollLocks();
  }, [active]);
  return /*#__PURE__*/React.createElement("div", {
    ref: lockRef
  });
};

BodyLock.defaultProps = {
  active: false
};
BodyLock.propTypes = {
  /** Boolean flag to indicate if the body lock is active */
  active: PropTypes.bool
};
export default BodyLock;